<template>
  <modal-base :is-open="isOpen">
    <div
      class="closeLayer"
      @click="emit('cancel')"
    ></div>
    <div class="c-popup-body -warning">
      <div class="c-popup-body__inner">
        <div class="c-popup-body__main">
          <div class="alertBlock">
            <div class="text">
              <slot name="text">よろしいですか？</slot>
            </div>
            <p class="alert-text"><slot name="alertText">この操作は取消できません。本当によろしいですか？</slot></p>
            <div class="button-area c-button -col2">
              <a
                href="javascript:void(0);"
                class="c-button-alert -alert"
                @click="emit('ok')"
              >
                <span class="label">{{ okLabel }}</span>
              </a>
              <div
                class="c-button-white -cancel"
                @click="emit('cancel')"
              >
                <span class="label">{{ cancelLabel }}</span>
              </div>
            </div>
          </div>
        </div>
        <span
          class="c-popup-body__close"
          @click="emit('cancel')"
        >
          <span class="c-popup-body__close-inner"></span>
        </span>
      </div>
    </div>
  </modal-base>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      isOpen?: boolean;
      okLabel?: string;
      cancelLabel?: string;
    }>(),
    {
      isOpen: false,
      okLabel: "OK",
      cancelLabel: "キャンセル"
    }
  )
  const emit = defineEmits<{
    (e: 'ok'): void,
    (e: 'cancel'): void,
  }>()
</script>

<style lang="scss" scoped>
</style>
